import { MenuCategoryEditPayload } from 'api/menuCategoryApi';
import { MenuCategory } from 'types/menuCategory';
import { isNumber } from 'utils/typeUtils';

/**
 * メニューカテゴリー編集フォーム
 */
export type MenuCategoryEditFormFields = {
  /** メニューカテゴリーID */
  id: string;
  /** メニューカテゴリー名 */
  name: string;
};

export const createMenuCategoryEditFormFields = ({
  id = '',
  name = '',
}: Partial<MenuCategoryEditFormFields>): MenuCategoryEditFormFields => ({
  id,
  name,
});

export const mapMenuCategoryToFormFields = ({
  id,
  name = '',
}: Partial<MenuCategory>): MenuCategoryEditFormFields => ({
  id: isNumber(id) ? id.toString() : '',
  name,
});

export const mapFormFieldsToMenuCategoryEditPayload = ({
  name,
}: MenuCategoryEditFormFields): MenuCategoryEditPayload => ({
  name,
});
